import React from 'react';
import { MousePointer2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';


const Mapa = () => {
   const [t, i18n] = useTranslation("global");
  // URL directa extraída del iframe de Google Maps
  const googleMapsUrl = "https://www.google.com/maps/place/B1902DOB,+Diag.+76+46,+B1902DOB+La+Plata,+Provincia+de+Buenos+Aires/@-34.91484488182228,-57.96911434463179,17z";

  return (
    <div className="w-full h-full flex flex-col gap-4">
      <div className="flex-1 rounded-lg overflow-hidden">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3271.6654254938608!2d-57.96911434463179!3d-34.91484488182228!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95a2e7ca1b97e331%3A0x9bb8029c08d43f4!2sB1902DOB%2C%20Diag.%2076%2046%2C%20B1902DOB%20La%20Plata%2C%20Provincia%20de%20Buenos%20Aires!5e0!3m2!1sen!2sar!4v1763121744542!5m2!1sen!2sar"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      <a
        href={googleMapsUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-zinc-600 flex items-center justify-center gap-2 hover:from-zinc-600 text-center hover:to-zinc-800 text-base md:text-lg px-6 py-2 rounded-lg font-messina tracking-wider font-light  shadow-lg transition-all transform hover:scale-105"
      >
        {t("mapa.llegar")} <MousePointer2 /> 
      </a>
    </div>
  );
};

export default Mapa;
